import type { TFunction } from 'i18next';

/** Controller hardware button labels; keys are stable Locize paths (`controller.inputButton.*`). */
export function translateControllerInputButton(buttonKey: string, t: TFunction): string {
  const k = String(buttonKey || '').toLowerCase();
  switch (k) {
    case 'a':
      return t('controller.inputButton.a', 'A');
    case 'b':
      return t('controller.inputButton.b', 'B');
    case 'x':
      return t('controller.inputButton.x', 'X');
    case 'y':
      return t('controller.inputButton.y', 'Y');
    case 'up':
      return t('controller.inputButton.up', 'Up');
    case 'down':
      return t('controller.inputButton.down', 'Down');
    case 'right':
      return t('controller.inputButton.right', 'Right');
    case 'left':
      return t('controller.inputButton.left', 'Left');
    case 'r1':
      return t('controller.inputButton.r1', 'R1');
    case 'r2':
      return t('controller.inputButton.r2', 'R2');
    case 'r4':
      return t('controller.inputButton.r4', 'R4');
    case 'l1':
      return t('controller.inputButton.l1', 'L1');
    case 'l2':
      return t('controller.inputButton.l2', 'L2');
    case 'l4':
      return t('controller.inputButton.l4', 'L4');
    default:
      return buttonKey || '';
  }
}

/** Drivebase panel button labels; keys are `drivebase.inputButton.*`. */
export function translateDrivebaseInputButton(buttonKey: string, t: TFunction): string {
  const k = String(buttonKey || '').toLowerCase();
  switch (k) {
    case 'up':
      return t('drivebase.inputButton.up', 'Up');
    case 'down':
      return t('drivebase.inputButton.down', 'Down');
    case 'right':
      return t('drivebase.inputButton.right', 'Right');
    case 'left':
      return t('drivebase.inputButton.left', 'Left');
    case 'back':
      return t('drivebase.inputButton.back', 'Back');
    case 'select':
      return t('drivebase.inputButton.select', 'Select');
    default:
      return buttonKey || '';
  }
}
